import React from 'react';
import Icon from '../../../components/AppIcon';

const RevenueMetricsPanel = ({ revenueMetrics }) => {
  return (
    <div className="bg-card rounded-xl border border-border p-4 sm:p-6">
      <h2 className="text-lg font-heading font-semibold text-foreground mb-4 flex items-center gap-2">
        <Icon name="DollarSign" size={20} strokeWidth={2} />
        Revenue Metrics
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-background rounded-lg p-4 border border-border">
          <div className="flex items-center justify-between mb-2">
            <p className="text-sm text-muted-foreground">Monthly Revenue</p>
            <div className="flex items-center gap-1 text-xs font-medium text-green-600">
              <Icon name="TrendingUp" size={14} strokeWidth={2} />
              <span>{revenueMetrics?.revenueTrend}%</span>
            </div>
          </div>
          <p className="text-2xl font-heading font-bold text-foreground">
            £{revenueMetrics?.monthlyRevenue?.toLocaleString()}
          </p>
        </div>

        <div className="bg-background rounded-lg p-4 border border-border">
          <p className="text-sm text-muted-foreground mb-2">Average Revenue Per User</p>
          <p className="text-2xl font-heading font-bold text-foreground">
            £{revenueMetrics?.averageRevenue?.toFixed(2)}
          </p>
        </div>

        <div className="bg-background rounded-lg p-4 border border-border">
          <p className="text-sm text-muted-foreground mb-2">Customer Lifetime Value</p>
          <p className="text-2xl font-heading font-bold text-foreground">
            £{revenueMetrics?.lifetimeValue?.toFixed(2)}
          </p>
        </div>

        <div className="bg-background rounded-lg p-4 border border-border">
          <p className="text-sm text-muted-foreground mb-2">Projected Annual</p>
          <p className="text-2xl font-heading font-bold text-foreground">
            £{(revenueMetrics?.monthlyRevenue * 12)?.toLocaleString()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default RevenueMetricsPanel;